module.exports = __webpack_public_path__ + "media/Diagnose John_neu_Stufe02.ba9f4b70.mp4";